import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { IconPlus } from '@prisjakt/ui/icon';

interface Expandable {
  expanded: boolean;
}

interface Disablable {
  disabled: boolean;
}

export const AccordionWrapper = styled.div`
  background-color: ${({ theme }) => theme.bg.tertiary};
  border-radius: ${layout.measurements.spacing100};
  padding: ${layout.measurements.spacing100};
  && {
    margin-bottom: ${layout.measurements.spacing100};
  }
`;

export const StyledHeader = styled.div<Disablable>`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing050};
  cursor: pointer;
`;

export const StyledIconPlus = styled(IconPlus)<Expandable>`
  transform: ${({ expanded }) => (expanded ? 'rotate(45deg)' : 'rotate(0deg)')};
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

export const StyledContent = styled.div`
  padding-top: ${layout.measurements.spacing100};
`;
export const StyledContentWrapper = styled.div<Expandable>`
  max-height: ${({ expanded }) => (expanded ? '500px' : '0')};
  transition: max-height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  overflow: hidden;
`;
